// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5411":"675a6c1a","6534":"ce99d352"}[chunkId] + ".chunk.css";
};